import { initialState } from ".";
import {
	GET_VENDOR_FAIL,
	GET_VENDOR_START,
	GET_VENDOR_SUCCESS,
	GET_VENDOR_PRODUCTS_SUCCESS,
	SET_CURRENT_CATEGORY,
	GET_VENDOR_ADDONS_SUCCESS
} from "../actions/vendor";

export default function (vendor = initialState.vendor, action) {
	switch (action.type) {

		case GET_VENDOR_START:
			return { ...vendor, loading: true }

		case GET_VENDOR_FAIL:
			return { ...vendor, loading: false }

		case GET_VENDOR_SUCCESS:
			return {
				...action.vendor,
				products: vendor.products,
				addOns: vendor.addOns,
				currentCategory: vendor.currentCategory,
				loading: false
			}

		case GET_VENDOR_PRODUCTS_SUCCESS:
			return {
				...vendor,
				products: action.products
			}

		case GET_VENDOR_ADDONS_SUCCESS:
			return {
				...vendor,
				addOns: action.addOns
			}

		case SET_CURRENT_CATEGORY:
			return {
				...vendor,
				currentCategory: action.category
			}

		default:
			return vendor;
	}
}